import * as React from "react";
import { useActiveFBOs } from "../containers/ActiveFBOContainer";
import { useApi } from "../containers/ApiContainer";
import { useIdentity } from "../containers/IdentityContainer";
import { setupSessionTracking } from "../utils/mixpanel";

/**
 * Hook to automatically track user sessions per FBO
 * Sessions are tracked both in the database and via Mixpanel
 */
export const useSessionTracking = () => {
  const { postgrest } = useApi();
  const { activeFBO } = useActiveFBOs();
  const { airplxIdentity } = useIdentity();

  // Setup Mixpanel session tracking when FBO or user changes
  React.useEffect(() => {
    if (activeFBO?.id && airplxIdentity?.userid && postgrest) {
      setupSessionTracking(postgrest, airplxIdentity.userid, activeFBO.id);
    }
  }, [activeFBO?.id, airplxIdentity?.userid, postgrest]);
};